import {CsvStatus} from "./csv-status";
import {CsvErrorList} from "./csv-error";
import {MeasurementPersistRequestCsv} from "./measurement-persist-request-csv";
import {MeasurementImportCsv} from "./measurement-import-csv";

export class CsvMeasurementData {
  measurement: MeasurementPersistRequestCsv | MeasurementImportCsv;
  fileIdentifier: string;
  status: CsvStatus;
  lineIdentifier: string;
  errors?: CsvErrorList;
}

export enum ImportCsvEntityType {
  DEVICE = 'DEVICE',
  ASSET = 'ASSET'
}
